import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "bankdata" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

import type { InitialBankAccountData } from '@src/view_models/BankAccount';

interface Props {
	bankData: InitialBankAccountData;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'PaymentSummarySection',
  props: {
    bankData: {}
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h3", null, _toDisplayString(_ctx.$t('form_summary_bank_details_header')), 1),
    _createElementVNode("ul", _hoisted_1, [
      _createElementVNode("li", null, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('form_summary_iban')), 1),
        _createTextVNode(" " + _toDisplayString(__props.bankData.iban), 1)
      ]),
      (__props.bankData.bic)
        ? (_openBlock(), _createElementBlock("li", _hoisted_2, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.$t('form_summary_bic')), 1),
            _createTextVNode(" " + _toDisplayString(__props.bankData.bic), 1)
          ]))
        : _createCommentVNode("", true),
      (__props.bankData.bankName)
        ? (_openBlock(), _createElementBlock("li", _hoisted_3, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.$t('form_summary_bank_name')), 1),
            _createTextVNode(" " + _toDisplayString(__props.bankData.bankName), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})